export default __webpack_public_path__ + "static/media/ballon.77dbc15f.png";